<template>
  <v-card class="shadow-xl cf-section-card" elevation="2">
    <v-card-title v-if="title" class="subtitle-1 font-weight-medium pb-2">
      {{ title }}
      <v-spacer />
      <slot name="title-actions" />
    </v-card-title>
    <v-divider v-if="title" />
    <v-card-text :class="dense ? 'py-4' : 'pa-6'">
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: { type: String, default: "" },
    dense: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.cf-section-card {
  border-radius: 8px;
  width: 100%;
}
</style>
